import Axios from 'axios'

import { transformResponse } from './Transformer'

const ServerUNC = Axios.create({
  baseURL: process.env.REACT_APP_API_URL_UNICODEOFICIAL,
  transformResponse: [transformResponse],
})
ServerUNC.defaults.auth = {
  username: process.env.REACT_APP_API_USER || '',
  password: process.env.REACT_APP_API_PASSWORD || '',
}

export default ServerUNC
